<template>
    <div>
        <b-table
            :empty-text="$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="items"
            :fields="fields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded document_request_dropdown"
        >
            <template #cell(buttons)="row">
                <b-dropdown variant="link btn-sm" boundary="window" no-caret class="compact-dropdown">
                    <template #button-content>
                        <i class="ri-more-fill text-muted" style="font-size: 1.2rem;"></i>
                    </template>
                    <div id="dropdownListHead">
                        <b-dropdown-item @click="cancelRequest(row.item.id)"
                                         v-if="checkPermission('documentrequest_cancel') && ['waiting','waiting_payment'].includes(row.item.status_code)">
                            <i class="ri-close-circle-line align-middle mr-2 text-muted"></i>
                            {{ $t('cancel') }}
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="row.item.delivery_type_code == 'online' && row.item.signature_type_code == 'electronic' && row.item.status_code == 'ready' && checkPermission('documentrequest_downloaddocument')"
                            @click="downloadDocument(row.item)">
                            <i class="ri-file-download-line align-middle mr-2 text-muted"></i>
                            {{ $t('download') }}
                        </b-dropdown-item>
                    </div>
                </b-dropdown>
            </template>
            <template #cell(status)="row">
                <div style="text-align: center">{{ row.item.status }}</div>
                <router-link class="d-flex flex-column" style="gap:4px" to="/epayment" tag="div">
                    <b-button variant="primary" style="line-height: 1" v-if="row.item.status === 'Ödeme Bekliyor'">
                        {{ $t('make_payment') }}
                    </b-button>
                </router-link>
            </template>
        </b-table>
    </div>
</template>

<script>
import DocumentRequestService from "@/services/DocumentRequestService";

/**
 * Document Request Tab Component
 */
export default {
    name: 'DocumentRequestTab',
    props: {
        stateData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            items: [],
            fields: [
                { key: 'buttons', label: '', thStyle: { width: '50px' }, tdClass: 'text-center' },
                { key: 'document_type', label: this.$t('document_type') },
                { key: 'count', label: this.$t('count') },
                { key: 'date', label: this.toUpperCase(this.$t('date')) },
                { key: 'signature_type', label: this.$t('signature_type') },
                { key: 'type_of_delivery', label: this.toUpperCase(this.$t('type_of_delivery')) },
                { key: 'address', label: this.toUpperCase(this.$t('address')) },
                { key: 'explanation', label: this.$t('explanation') },
                { key: 'price', label: this.$t('price') },
                { key: 'responsible_name', label: this.$t('responsiblePerson') },
                { key: 'responsible_email', label: this.$t('responsible_person_email') },
                { key: 'status', label: this.$t('status') },
                { key: 'id', label: '', thClass: 'd-none', tdClass: 'd-none' },
            ],
        };
    },
    methods: {
        fetchData() {
            // Note: In the original code, active_student_program.id was hardcoded to 48860 in catchTab.
            // We use the prop but respect the original logic if needed.
            const studentProgramId = this.stateData?.active_student_program?.id || 48860;
            
            DocumentRequestService.getStudentDocuments(studentProgramId)
                .then(response => {
                    this.items = [];
                    Object.keys(response.data.data).forEach(key => {
                        let item = response.data.data[key];
                        this.items.push({
                            document_type: this.getLocaleText(item, 'document_type'),
                            count: item.count,
                            date: item.date,
                            signature_type: this.getLocaleText(item, 'signature_type'),
                            type_of_delivery: this.getLocaleText(item, 'delivery_type'),
                            address: item.address,
                            explanation: item.explanation,
                            delivery_type_code: item.delivery_type_code,
                            signature_type_code: item.signature_type_code,
                            status_code: item.status_code,
                            price: item.price == 0 ? this.$t('priceless') : item.price + ' TL',
                            responsible_name: item.responsible_name,
                            responsible_email: item.responsible_email,
                            status: item[this.getLocaleField('status')],
                            id: item.id
                        });
                    });
                })
                .catch(err => this.showErrors(err));
        },
        cancelRequest(id) {
            this.$swal.fire({
                text: this.$t('document_request_cancel_statement'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no'),
            }).then(response => {
                if (response.isConfirmed == true) {
                    DocumentRequestService.cancelRequest(id)
                        .then(response => {
                            this.$toast.success(this.$t('api.' + response.data.message));
                            this.fetchData();
                        })
                        .catch(err => this.showErrors(err));
                }
            });
        },
        downloadDocument(row) {
            const studentProgramId = this.stateData?.active_student_program?.id || 48860;
            DocumentRequestService.downloadDocument(studentProgramId, row.id)
                .then(response => {
                    this._downloadFile(response, row.document_type + '.pdf');
                })
                .catch(e => {
                    this.$toast.error(this.$t('api.' + (e.data?.message || 'error')));
                });
        },
    },
    created() {
        this.fetchData();
    }
};
</script>

<style scoped>
.compact-dropdown >>> .dropdown-toggle {
    padding: 0;
    line-height: 1;
}
</style>
